<template>
    <div id="review-cancellation-policies" class="review-cancellation-policies">
        <div v-if="processedPeriods.length" class="review-cancellation-policies__warning">
            Before proceeding, please review this host's cancellation policy:
        </div>
        <div v-if="processedPeriods.length" class="review-cancellation-policies__refunds">
            <div class="review-cancellation-policies__refunds__cancel_by">Cancel by</div>
            <div v-for="(period, index) in processedPeriods" :key="index">
                <hr />
                <div class="review-cancellation-policies__refunds__refund">
                    <div class="review-cancellation-policies__refunds__refund__date">
                        {{ period.cancel_by_date }}
                    </div>
                    <div class="review-cancellation-policies__refunds__refund__policy">
                        {{ period.description }}
                    </div>
                </div>
            </div>
        </div>
        <div v-else>This reservation is not eligible for a refund if canceled.</div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import format from 'date-fns/format';
    import Card from '../../../generic/card/card.vue';

    export default {
        name: 'OnlineBookingCheckoutReviewCancellationPolicies',
        components: {
            Card,
        },
        computed: {
            ...mapGetters('onlineBooking', ['reservation']),
            processedPeriods() {
                const cancellationPolicy = this.reservation.cancellation_policy || {};
                const cancellationFee = parseFloat(cancellationPolicy.cancellation_fee || 0);
                const periods = cancellationPolicy.cancellation_periods || [];
                const processed = periods.map((period) => {
                    let description = '';
                    const formattedDate = format(new Date(period.cancel_by_date), 'MMM dd');
                    if (period.refund_percent === 100) {
                        description = 'Full refund.';
                        if (cancellationFee > 0) {
                            description += ` Less $${cancellationFee.toFixed(2)} cancellation fee.`;
                        }
                    } else if (period.refund_percent > 0) {
                        description = `Partial refund. Get back ${period.refund_percent}% of what you paid.`;
                        if (cancellationFee > 0) {
                            description += ` Less $${cancellationFee.toFixed(2)} cancellation fee.`;
                        }
                    } else description += 'No refund.';
                    return { cancel_by_date: formattedDate, description };
                });
                return processed;
            },
        },
    };
</script>

<style lang="scss" scoped>
    #review-cancellation-policies .review-cancellation-policies {
        &__warning {
            margin-bottom: 2rem;
        }
        &__refunds {
            &__cancel_by {
                font-weight: bold;
            }

            &__refund {
                display: flex;
                justify-content: space-between;

                &__date {
                    width: 25%;
                    font-weight: bold;
                }

                &__policy {
                    width: 75%;
                }
            }
        }
    }
</style>
